    export module TextUtils {

        export function getTextBounds(text: string, size?: number,
                font?: string, bold?: boolean) {

            var span = document.createElement("span");
            span.innerHTML = text;
            span.style.position = 'absolute';
            span.style.top = '-9999px';
            span.style.left = '-9999px';
            span.style.fontWeight = bold ? 'bold' : 'normal';

            if (font) {
                span.style.fontFamily = font;
            }

            if (size) {
                span.style.fontSize = size + 'px';
            }

            document.body.appendChild(span);
            var width: number = span.offsetWidth;
            var height: number = span.offsetHeight;
            document.body.removeChild(span);
            return { width: width, height: height };
        }

    }// end Text module

    export module NumberUtils {

        var defaultPattern = [0, 0.1, 0.12, 0.15, 0.2, 0.25, 0.3, 0.35, 0.5, 0.6, 0.7, 0.75, 0.8, 0.9, 1];

       	export function niceFloorWithPrecision(x: number, precision: number) {
			var roundedNr = niceRoundWithPrecision(x, precision, -1);
            return roundedNr;
		}

        export function niceRoundWithPrecision(x: number, precision: number, direction: number = 1) {
				precision = precision || 1;

                precision = Math.log10(precision);
				var signum = Math.sign(precision);
				precision = Math.abs(precision);
				var exp = Math.ceil(precision) * signum + 1;

				var power = Math.pow(10,exp);

				x = x / power;
				var partInt = parseInt(x.toString());

				var partFrac = (x - partInt);
				partFrac = niceRound(partFrac, direction);

				return (partInt + partFrac) * power;
		}

        export function niceRound(x: number,
                direction: number = 1,
                pattern: number[] = defaultPattern) {

            if (x == 0) {
                return 0;
            }

            var signum = Math.sign(x);
            x = Math.abs(x);
            var exp = Math.ceil(Math.log10(x));
            var powX10 = Math.pow(10, exp);
            x = x / powX10;
            var i: number;
            direction *= signum;
            if(direction < 0) { //round down
                for (i = pattern.length-1; i >= 0  && x < pattern[i]; i--) { }
                ;
            }
            else { //round up
                for (i = 0; i < pattern.length && x > pattern[i]; i++) { }
                ;
            }
            x = pattern[i] * powX10;
            return x * signum;
        }

        export function niceFloor(x: number, pattern : number[] = defaultPattern) {
            return niceRound(x, -1, pattern);
        }

        export function divisibleRound(x: number, divisor: number) {
            if (x < 0) {
            	return Math.floor(x / divisor) * divisor;
            }
            return Math.ceil(x / divisor) * divisor;
        }

        export function divisibleFloor(x: number, divisor: number) {
            return Math.floor(x / divisor) * divisor;
        }

    }
